import React, { useState } from 'react';
import { apiService } from '../../services/api';
import Header from '../../components/customer/Header';
import WhatsAppButton from '../../components/customer/WhatsAppButton';
import SEO from '../../components/common/SEO';
import styles from './MyOrders.module.css';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [emailInput, setEmailInput] = useState('');
  const [showEmailForm, setShowEmailForm] = useState(true);

  const loadOrders = async (userEmail) => {
    setLoading(true);
    try {
      const data = await apiService.getOrders({ email: userEmail, limit: 50 });
      setOrders(data.orders || []);
    } catch (error) {
      console.error('Error loading orders:', error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitEmail = (e) => {
    e.preventDefault();
    if (!emailInput.trim()) return;
    setEmail(emailInput);
    setShowEmailForm(false);
    loadOrders(emailInput);
  };

  const handleChangeEmail = () => {
    setShowEmailForm(true);
    setOrders([]);
  };

  const getStatusLabel = (status) => {
    const labels = {
      pendiente: 'Pendiente',
      en_proceso: 'En Proceso',
      enviada: 'Enviada',
      entregada: 'Entregada',
      cancelada: 'Cancelada'
    };
    return labels[status] || status;
  };

  if (showEmailForm) {
    return (
      <>
        <SEO 
          title="Mis Órdenes - Nexa Global"
          description="Consulta el estado de tus pedidos"
          noindex={true}
        />
        <Header />
        <div className={styles.container}>
          <div className={styles.emailForm}>
            <h1>Consulta tus Órdenes</h1>
            <p>Ingresa tu correo electrónico para ver el estado de tus pedidos</p>
            <form onSubmit={handleSubmitEmail}>
              <input
                type="email"
                placeholder="tu@email.com"
                value={emailInput}
                onChange={(e) => setEmailInput(e.target.value)}
                className={styles.emailInput}
                required
              />
              <button type="submit" className={styles.submitButton}>
                Ver mis órdenes
              </button>
            </form>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEO 
        title="Mis Órdenes - Nexa Global"
        description="Consulta el estado de tus pedidos"
        noindex={true}
      />
      <Header />
      <div className={styles.container}>
        <div className={styles.header}>
          <div>
            <h1>Mis Órdenes</h1>
            <p className={styles.emailDisplay}>{email}</p>
          </div>
          <button onClick={handleChangeEmail} className={styles.changeEmailButton}>
            Cambiar correo
          </button>
        </div>

        {loading ? (
          <div className={styles.loading}>Cargando órdenes...</div>
        ) : orders.length === 0 ? (
          <div className={styles.noOrders}>
            <p>No tienes órdenes registradas con este correo.</p>
          </div>
        ) : (
          <div className={styles.ordersGrid}>
            {orders.map((order) => (
              <div key={order.id} className={styles.orderCard}>
                <div className={styles.orderHeader}>
                  <div>
                    <span className={styles.orderLabel}>Orden</span>
                    <span className={styles.orderId}>#{order.id.slice(0, 8)}</span>
                  </div>
                  <span className={`${styles.statusBadge} ${styles[order.status]}`}>
                    {getStatusLabel(order.status)}
                  </span>
                </div>

                <div className={styles.orderDate}>
                  {new Date(order.created_at).toLocaleString('es-SV', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </div>

                <div className={styles.orderProducts}>
                  <h3>Productos:</h3>
                  {(order.products || []).map((product, index) => (
                    <div key={index} className={styles.productItem}>
                      <span className={styles.productName}>{product.name}</span>
                      <span className={styles.productQuantity}>x{product.quantity}</span>
                      <span className={styles.productPrice}>
                        ${(product.price * product.quantity).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>

                <div className={styles.orderFooter}>
                  <div className={styles.deliveryInfo}>
                    <strong>Entregar a:</strong>
                    <p>{order.user_name}</p>
                    <p>{order.user_phone}</p>
                    <p>{order.user_address}</p>
                  </div>
                  <div className={styles.orderTotal}>
                    <span className={styles.totalLabel}>Total:</span>
                    <span className={styles.totalAmount}>${order.total?.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <WhatsAppButton />
    </>
  );
};

export default MyOrders;
